<template>
    <div class="bg-teal-400 rounded-lg p-5">
           <h1 class="text-lg font-bold text-slate-900 mb-5">Data Surat Kontrol</h1>
           <table width="100%" border="0">
                <tr>
                    <td>Jenis</td>
                    <td class="font-bold">{{suratKontrol.namaJnsKontrol}}</td>
                </tr>
                <tr>
                    <td>Tanggal Kontrol</td>
                    <td class="font-bold">{{suratKontrol.tglRencanaKontrol}}</td>
                </tr>
                <tr>
                    <td>Poli Rujukan</td>
                    <td class="font-bold">{{suratKontrol.namaPoliTujuan}}</td>
                </tr>
                <tr>
                    <td>Kode Dokter</td>
                    <td class="font-bold">{{suratKontrol.kodeDokter}}</td>
                </tr>
                <tr>
                    <td>Nama Dokter</td>
                    <td class="font-bold">{{suratKontrol.namaDokter}}</td>
                </tr>
                <tr>
                    <td></td>
                    <td class="font-bold"></td>
                </tr>
                <tr>
                    <td>Poli Asal</td>
                    <td class="font-bold">{{suratKontrol.sep.poli}}</td>
                </tr>
                <tr>
                    <td>No SEP Asal</td>
                    <td class="font-bold">{{suratKontrol.sep.noSep}}</td>
                </tr>
                <tr>
                    <td></td>
                    <td class="font-bold"></td>
                </tr>
                <tr>
                    <td>Terbit SEP</td>
                    <td class="font-bold">{{suratKontrol.sep.tglSep}}</td>
                </tr>
           </table>
       </div>
</template>


<script>
   import { Link } from '@inertiajs/inertia-vue3'
   export default{
       props: {
           suratKontrol: Object,
       },
       components: {
           Link
       },
   }
</script>